if (!customElements.get("featured-categories")) {
  customElements.define(
    "featured-categories",
    class FeaturedCategories extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector("[data-slider]");
        this.mount();
      }

      mount() {
        if (!this.#sliderEl) {
          return console.error(
            "featured-categories: unable to initialize component, missing required elements",
          );
        }

        this.#sliderInstance = new Swiper(this.#sliderEl, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
          },
        });
      }

      get slider() {
        return this.#sliderInstance;
      }
    },
  );
}
